import styled from 'styled-components';
import { THEME } from '../../../../../themes';
import { HorizontalDividerContainer } from '../../../../../components/Common/horizontal-divider/horizontal-divider.styled';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${THEME.SPACING.MEDIUM};
  width: 720px;
  align-items: center;
`;

export const DividerContainer = styled.div`
  display: flex;
  gap: ${THEME.SPACING.BASE};
  align-items: center;
  width: 100%;
  
  & ${HorizontalDividerContainer} {
    width: 100%;
  }
`;

export const DividerText = styled.div`
  flex-shrink: 0;
  color: ${THEME.COLORS.CONTENT_A};
`;

export const InputContainer = styled.div`
  position: relative;
  font-size: 24px;
  text-align: center;

  & .input-wrapper {
    height: 32px;
  }
  
  & input {
    text-align: center;
  }
`;

export const GuidanceModalButtonWrapper = styled.div`
  margin-top: -${THEME.SPACING.LOOSE};
`;
